import * as React from "react";
import {
  Input as NextUIInput,
  InputProps as InputPropsNextUI,
} from "@nextui-org/react";
import { cn } from "../../lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

const inputVarients = cva("", {
  variants: {
    size: {
      default: "h-[48px]",
      lg: "h-[60px] pb-[4px]",
    },
    rounded: {
      full: "rounded-full",
      none: "rounded-none",
      default: "rounded-[8px]",
    },
    fontsize: {
      default: "!text-[12px] placeholder:!text-[12px]",
    },
  },
  defaultVariants: {
    size: "default",
    rounded: "default",
    fontsize: "default",
  },
});

export interface InputProps
  extends Omit<InputPropsNextUI, "size">,
    VariantProps<typeof inputVarients> {
  label?: string;
  desc?: string;
  fontsize?: "default";
  labelClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      size,
      rounded,
      fontsize,
      labelClassName,
      type,
      label,
      desc,
      ...props
    },
    ref
  ) => {
    return (
      <div className="flex flex-col items-start">
        {label && (
          <label
            htmlFor={props.id}
            className={cn(
              " text-[20px] font-medium tracking-[-3%] leading-[120%] mb-[8px]",
              labelClassName
            )}
          >
            {label}
          </label>
        )}

        <NextUIInput
          type={type}
          classNames={{
            inputWrapper: [
              "w-full",
              "!px-[12px]",
              "!shadow-none",
              "!bg-third-500",
              "hover:bg-third-400",
              "group-data-[focus=true]:bg-third-500",
              "!cursor-text",
              inputVarients({ size, rounded }),
            ],
            mainWrapper: "w-full",
            input: cn(" placeholder:text-[#888]", inputVarients({ fontsize })),
          }}
          className={cn(`w-full`, className)}
          ref={ref}
          {...props}
        />
        {desc && (
          <span className="text-[12px] font-medium text-third-100 mt-[4px]">
            {desc}
          </span>
        )}
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };